import { addAllToRecord, objectWithoutKeys, setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { SuggestedGroupsDismissFulfilledAction } from '../../domains/suggestedGroupDismiss/actions.types';
import type {
  SuggestedGroupsLoadAction,
  SuggestedGroupsLoadMoreAction,
  SuggestedGroupsLoadMoreFulfilledAction,
} from '../../domains/suggestedGroups/actions.types';

import type { SuggestedGroups } from './types';

const loadMoreSuggestedGroupFulfilled = (state: SuggestedGroups, action: SuggestedGroupsLoadMoreFulfilledAction) => {
  if (state.fulfilled) {
    return {
      ...state,
      fulfilled: addAllToRecord(state.fulfilled, action.payload.entities.suggestedGroups),
    };
  }

  return setFulfilled(action.payload.entities.suggestedGroups);
};

const dismissSuggestedGroupFulfilled = (state: SuggestedGroups, action: SuggestedGroupsDismissFulfilledAction) => {
  if (!state.fulfilled) {
    return state;
  }

  return {
    ...state,
    fulfilled: objectWithoutKeys(state.fulfilled, [action.payload.groupId]),
  };
};

export type SuggestedGroupsAction =
  | SuggestedGroupsLoadAction
  | SuggestedGroupsLoadMoreAction
  | SuggestedGroupsDismissFulfilledAction;

const initialState: SuggestedGroups = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const reducer: Reducer<SuggestedGroups, SuggestedGroupsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'SUGGESTED_GROUPS.LOAD_PENDING': {
      return setPending();
    }
    case 'SUGGESTED_GROUPS.LOAD_REJECTED': {
      return setRejected(action.payload.error);
    }
    case 'SUGGESTED_GROUPS.LOAD_FULFILLED':
      return setFulfilled(action.payload.entities.suggestedGroups);
    case 'SUGGESTED_GROUPS.LOAD_MORE_FULFILLED':
      return loadMoreSuggestedGroupFulfilled(state, action);
    case 'SUGGESTED_GROUPS.DISMISS_FULFILLED':
      return dismissSuggestedGroupFulfilled(state, action);
    default:
      return state;
  }
};

export default reducer;
